import { render, staticRenderFns } from "./NumberExercisesClass.vue?vue&type=template&id=43050796&scoped=true&"
import script from "./NumberExercisesClass.vue?vue&type=script&lang=js&"
export * from "./NumberExercisesClass.vue?vue&type=script&lang=js&"
import style0 from "./NumberExercisesClass.vue?vue&type=style&index=0&id=43050796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43050796",
  null
  
)

export default component.exports